import React, { useCallback, useEffect, useMemo, useState } from 'react'
import Header from '../Header/Header.js';
import Footer from '../Footer/Footer.js';
import SideBar from './SideBar.js';
import { BsBox } from 'react-icons/bs';
import Select from "react-select";
import { FiDownload, FiFilter, FiX } from "react-icons/fi";
import * as XLSX from 'xlsx';
import { useLazyQuery, useMutation, useQuery } from '@apollo/client';
import { GET_NDR_COUNT, GET_NDR_LIST } from '../graphql/Query/Order.js';
import Table from "../components/Table/index.jsx";
import { NDRTableColumns } from '../components/Constant/index.js';
// import { capitalizeFirstLetter } from "../../OrderPage/AllOrders.js";
import {
    Dialog,
    DialogPanel,
    Popover,
    PopoverButton,
    PopoverGroup,
    PopoverPanel,
    Tab,
    TabGroup,
    TabList,
    TabPanel,
    TabPanels,
    Transition,
    TransitionChild,
    DialogTitle
} from '@headlessui/react';
import { capitalizeFirstLetter } from './AllOrders.js';
import moment from 'moment';
import { IoChevronDownCircleOutline, IoClose } from 'react-icons/io5';
import { FaAngleDown, FaCaretDown } from 'react-icons/fa6';
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { CREATE_NDR } from '../graphql/Mutation/Ordre.js';
import { toast } from 'react-toastify';
import SpinLoader from '../components/SpinLoader.js';
import DateFilter from '../Common/DateRange.js';
import { typeOptions } from '../DomesticSellerOrder/AllOrderSeller.js';
import { getDateRange } from '../Common/GetDateRange.js';
import NDRTableHistory from './NDRTableHistory.js';

const validationSchema = Yup.object().shape({
    action: Yup.string().required("Action is required"),
    date: Yup.string()
        .nullable()
        .when("action", (action, schema) =>
            action === "re-attempt" ? schema.required("Re-attempt date is required") : schema
        ),
    address_1: Yup.string()
        .nullable()
        .when("action", (action, schema) =>
            action === "change_address" ? schema.required("Address 1 is required") : schema
        ),
    address_2: Yup.string()
        .nullable()
        .when("action", (action, schema) =>
            action === "change_address" ? schema.required("Address 2 is required") : schema
        ),
    name: Yup.string()
        .nullable()
        .when("action", (action, schema) =>
            action === "change_address" ? schema.required("Name is required") : schema
        ),
    phone: Yup.string()
        .nullable()
        .when("action", (action, schema) =>
            action === "change_phone"
                ? schema
                    .matches(/^[0-9]+$/, "Phone number must be digits")
                    .min(10, "Phone number must be at least 10 digits")
                    .required("Phone number is required")
                : schema
        ),
});


const NDRDash = () => {

    const [open, setOpen] = useState(false)
    const [selectedPaymentType, setSelectedPaymentType] = useState('');
    const [toggleCleared, settoggleCleared] = useState(false);
    const [forceUpdate, setForceUpdate] = useState(0);
    const [openSideMenu, setOpenSideMenu] = useState(false);
    const [selectedRow, setselectedRow] = useState([]);
    const [selectedRowData, setselectedRowData] = useState([]);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [orderData, setOrderData] = useState([]);
    const [orderStatus, setorderStatus] = useState("actionRequired");
    const [isOpen, setIsOpen] = useState(false);
    const [activeTab, setActiveTab] = useState("Action Required");
    // console.log('✌️activeTab --->', activeTab);
    const [showFilters, setShowFilters] = useState(true);
    const [expandedRows, setExpandedRows] = useState({});

    const toggleRow = (orderId) => {
        setExpandedRows((prev) => ({
            ...prev,
            [orderId]: !prev[orderId],
        }));
    };
    const handleShowHistory = (row) => {
        setselectedRowData(row); // Store the selected row data
        setOpen(true); // Open the history modal
    };

    const [createNDRAction, { loading: loaderCreateNdr }] = useMutation(CREATE_NDR);
    const [finalRange, setFinalRange] = useState({
        filterType: "Last 30 Days",
        startDate: new Date(),
        endDate: new Date(),
    });
    const [filter, setFilter] = useState('');
    const [filterOrder, setFilterOrder] = useState('');
    const [awbNumber, setawbNumber] = useState('');
    const [fetchAllOrders] = useLazyQuery(GET_NDR_LIST, {
        fetchPolicy: "cache-and-network"
    });
    const { filterType, startDate, endDate } = finalRange;
    const isoStart = startDate?.toISOString();
    const [searchUser, setSearchUser] = useState('');
    const isoEnd = endDate?.toISOString();
    // const [isOpen, setIsOpen] = useState(false);
    const { data: GetOrderOrder, loading, refetch } = useQuery(GET_NDR_LIST, {
        variables: {
            page: page,
            limit,
            "sort": { key: "createdAt", type: -1 },
            paymentType: selectedPaymentType,
            "filter": filter?.trim(),
            from: finalRange?.startDate?.toISOString(), // Use updated startDate
            to: finalRange?.endDate?.toISOString(),
            status: orderStatus,
        },
        fetchPolicy: "cache-and-network",
    });

    const { data: NDRDataCount, refetch: refetchNDRCount } = useQuery(GET_NDR_COUNT, {
        variables: {
            paymentType: selectedPaymentType,
            "filter": filter?.trim(),
            from: finalRange?.startDate?.toISOString(), // Use updated startDate
            to: finalRange?.endDate?.toISOString(),
        },
        fetchPolicy: "cache-and-network",
    });
    const handlePagination = (page) => {
        // setLoader(true);
        setPage(page?.selected);
    };
    const handleSearch = (e, awb) => {
        if (awb === 'orderId') {
            setFilterOrder(e.target.value);
            setFilter(e.target.value)
        } else if (awb === 'awbNumber') {
            setFilter(e.target.value);
            setawbNumber(e.target.value)
        } else {
            setFilter(e.target.value);
        }
        setPage(1);
        handleClear();
    }
    // console.log('✌️GetOrderOrder --->', GetOrderOrder);
    useEffect(() => {
        if (GetOrderOrder?.getNDRList?.data) {
            setOrderData(GetOrderOrder?.getNDRList?.data);
        }
    }, [GetOrderOrder]);
    useEffect(() => {
        setForceUpdate(prev => prev + 1);
    }, [activeTab]);
    const handleTabClick = (tab) => {
        setActiveTab(tab);
        if (tab === 'Action Required') {
            setorderStatus('actionRequired');
        } else if (tab === 'Action Requested') {
            setorderStatus('actionRequested');
        } else if (tab === 'RTO') {
            setorderStatus('rto');
        } else if (tab === 'Delivered') {
            setorderStatus('delivered');
        }
        handleClear();
    };
    const handleClear = () => {
        settoggleCleared(!toggleCleared)
        setselectedRow([]);
    }
    const onSelectedRowsChange = (data) => {
        // console.log('✌️data --->', data);
        if (data?.selectedCount > 0) {
            const awb = data?.selectedRows?.map((d) => d?.awb_number)
            // console.log('awb --->', awb);
            setselectedRow(awb);
        } else {
            handleClear();
        }
    }
    const renderActionCell = useCallback(
        (row) => {
            // console.log('✌️activeTab inside useCallback:', activeTab); // Should always log updated value

            if (activeTab === "Action Required") {
                return (
                    <button
                        onClick={() => {
                            setselectedRow([row?.awb_number]);
                            setOpenSideMenu(true);
                        }}
                        className="flex items-center gap-2 px-3 text-xs py-1 text-[#5C74FB] border border-[#5C74FB] rounded-md shadow-sm hover:shadow-md hover:bg-[#5C74FB] hover:text-white transition duration-200"
                    >
                        Action
                    </button>

                );
            } if (activeTab === "RTO") {
                return (
                    <span>-</span>
                )
            } else if (["RTO", "Action Requested", "Delivered"].includes(activeTab)) {
                if (!row?.ndr_history || row?.ndr_history?.length === 0) {
                    return "No History";
                }

                const sortedNDRHistory = [...row.ndr_history].sort(
                    (a, b) => new Date(b?.event_date) - new Date(a?.event_date)
                );

                const latestNDR = sortedNDRHistory[0];


                return (
                    <div className="tooltip-container text-xs">
                        {latestNDR?.courier_remarks?.split(" ").map((word, index) => {
                            const cleanedWord = word.replace(/_/g, " ");
                            const keywords = ["re-attempt", "change address", "change phone"];

                            return keywords.includes(cleanedWord.toLowerCase()) ? (
                                <span key={index} style={{ color: "green", textTransform: "uppercase" }}>
                                    {cleanedWord.toUpperCase()}{" "}
                                </span>
                            ) : (
                                <span key={index}>{cleanedWord} </span>
                            );
                        })}
                        <br />
                    </div>
                );
            }
        },
        [activeTab] // ✅ This ensures `activeTab` updates correctly
    );


    const NDRTableColumns = useMemo(() => {
        return [
            // {
            //     name: "No.",
            //     sortable: true,
            //     cell: (row, index) => index + 1,
            // },
            {
                name: "NDR Date",
                sortable: true,
                selector: (row) => (
                    <span className="text-xs">
                        {row.ndr_history.length > 0
                            ? moment([...row.ndr_history].sort((a, b) => new Date(a?.event_date) - new Date(b?.event_date))[0]?.event_date).format("DD/MM/YYYY")
                            : "N/A"}
                    </span>
                ),
            },
            {
                name: "Order",
                sortable: true,
                selector: (row) => row?.order_number,
                cell: (row) => <span style={{ color: "#5C74FB", fontWeight: "500", cursor: "pointer" }} className='text-xs' onClick={() => window.open(`/singletrack?id=${row?.id}`, "_blank")}>{row.order_number}</span>,
                width: "160px",
            },
            {
                name: "Product",
                sortable: true,
                selector: (row) => row?.ProductName || "----",
                cell: (row) => (
                    <div
                        className="truncate max-w-[100px] text-xs cursor-pointer"
                        title={`Product Name: ${row?.ProductName || "----"}`}
                    >
                        {row?.ProductName || "----"}
                    </div>
                ),
            },


            // {
            //     name: "Product",
            //     sortable: true,
            //     selector: (row) => row?.ProductName || "----",
            //     cell: (row) => (
            //         <div className="tooltip-container">
            //             <div className="truncate max-w-[100px] overflow-hidden cursor-pointer">
            //                 {row?.ProductName || "----"}
            //             </div>
            //             <div className="tooltip-text tooltip-above">{row?.ProductName || "----"}
            //             </div>
            //         </div>
            //     ),
            // },


            // {
            //     name: "Customer",
            //     selector: row =>
            //         `${row?.deliveryAddress?.name || "----"}, ${row?.deliveryAddress?.address1 || "----"}, ${row?.deliveryAddress?.city || "----"}, ${row?.deliveryAddress?.stateId?.name || "----"} - ${row?.deliveryAddress?.zipCode || "----"}`,
            //     cell: (row) => (
            //         <div className="truncate max-w-xs cursor-pointer" title={
            //             `${row?.deliveryAddress?.name || "----"}, ${row?.deliveryAddress?.address1 || "----"}, ${row?.deliveryAddress?.city || "----"}, ${row?.deliveryAddress?.stateId?.name || "----"} - ${row?.deliveryAddress?.zipCode || "----"}`
            //         }>
            //             {row?.deliveryAddress?.name || "----"}
            //         </div>
            //     ),
            // },
            {
                name: "Customer",
                sortable: true,
                selector: (row) => `${row?.deliveryAddress?.name || "----"} - ${row?.deliveryAddress?.address || "----"}`,
                cell: (row) => (
                    <div
                        className="truncate max-w-xs cursor-pointer text-xs"
                        title={`Name: ${capitalizeFirstLetter(row?.deliveryAddress?.name || "----")}
            Phone: ${row?.deliveryAddress?.phone || "----"}
            To: ${capitalizeFirstLetter(row?.deliveryAddress?.address1 || "----")} 
            ${capitalizeFirstLetter(row?.deliveryAddress?.city || "----")}. 
            ${capitalizeFirstLetter(row?.deliveryAddress?.stateId?.name || "----")} - ${row?.deliveryAddress?.zipCode || "----"}`}
                    >
                        {row?.deliveryAddress?.name || "----"} <br />
                        {row?.deliveryAddress?.phone || "----"}
                    </div>
                ),
            },


            // {
            //     name: "Customer",
            //     sortable: true,
            //     selector: (row) => `${row?.deliveryAddress?.name} - ${row?.deliveryAddress?.address}`,
            //     cell: (row) => (
            //         <div className="tooltip-container">
            //             {row?.deliveryAddress?.name}<br />
            //             {row?.deliveryAddress?.phone}
            //             <div className="tooltip-text tooltip-above">
            //                 Name. {capitalizeFirstLetter(row?.deliveryAddress?.name)} <br />
            //                 To. {capitalizeFirstLetter(row?.deliveryAddress?.address1)}{" "}
            //                 {capitalizeFirstLetter(row?.deliveryAddress?.city)}.{" "}
            //                 {capitalizeFirstLetter(row?.deliveryAddress?.stateId?.name)} -{" "}
            //                 {row?.deliveryAddress?.zipCode} <br />
            //                 Mo. {row?.deliveryAddress?.phone}
            //             </div>
            //         </div>
            //     ),
            // },
            {
                name: "Payment",
                sortable: true,
                selector: (row) => (<span className="text-xs">
                    ₹{row?.ProductPrice} ({row?.payment_type})
                </span>),
                // width: "160px",
            },
            {
                name: "AWB",
                sortable: true,
                selector: (row) => row?.awb_number,
                cell: (row) => <span style={{ color: "#5C74FB", fontWeight: "500", cursor: "pointer" }} className='text-xs' onClick={() => window.open(`/trackcourier?awb=${row.awb_number}`, "_blank")}>{row.awb_number}</span>,
                width: "150px",
            },
            {
                name: "Status",
                sortable: true,
                selector: (row) => row?.status,
                cell: (row) => (
                    <span
                        className="capitalize text-xs"
                    >
                        {row?.status}
                    </span>
                ),
                // minWidth: "160px",   
            },
            {
                name: "Exception Info",
                sortable: true,
                width: "200px",
                selector: (row) => {
                    if (!row?.ndr_history || row?.ndr_history?.length === 0) return "No History";

                    // Sort ndr_history by event_date in descending order (latest first)
                    const sortedNDRHistory = [...row?.ndr_history].sort(
                        (a, b) => new Date(b?.event_date) - new Date(a?.event_date)
                    );

                    // Get the latest entry
                    const latestNDR = sortedNDRHistory[0];
                    const latestCourierAttempt = sortedNDRHistory?.find(entry => entry.By === "courier");

                    return `${latestNDR?.total_attempts || latestCourierAttempt?.total_attempts} Attempt(s) - ${latestNDR?.courier_remarks || "No Remarks"}`;
                },
                cell: (row) => {
                    if (!row?.ndr_history || row?.ndr_history?.length === 0) {
                        return <div className="truncate max-w-xs text-xs">No History</div>;
                    }

                    // Sort ndr_history by event_date in descending order (latest first)
                    const sortedNDRHistory = [...row?.ndr_history].sort(
                        (a, b) => new Date(b?.event_date) - new Date(a?.event_date)
                    );

                    // Get the latest entry
                    const latestNDR = sortedNDRHistory[0];
                    const latestCourierAttempt = sortedNDRHistory?.find(entry => entry.By === "courier");

                    return (
                        <div
                            className="truncate max-w-xs cursor-pointer text-xs"
                            title={`Attempts: ${latestNDR?.total_attempts || latestCourierAttempt?.total_attempts}
Courier Remarks: ${latestNDR?.courier_remarks || "No Remarks"}`}
                        >
                            <div className="flex flex-col space-y-1">
                                <span className="text-xs text-green-600">
                                    {latestNDR?.total_attempts || latestCourierAttempt?.total_attempts} Attempt(s)
                                </span>
                                <span className="text-xs text-gray-700">
                                    {latestNDR?.courier_remarks || "No Remarks"}
                                </span>
                                <p className="text-blue-600 cursor-pointer" onClick={() => handleShowHistory(row)}>
                                    Show History
                                </p>
                            </div>
                        </div>

                    );
                },
            },

            // {
            //     name: "Exception Info",
            //     sortable: true,
            //     selector: (row) => {
            //         if (!row?.ndr_history || row?.ndr_history?.length === 0) return "No History";

            //         // Sort ndr_history by event_date in descending order (latest first)
            //         const sortedNDRHistory = [...row?.ndr_history].sort(
            //             (a, b) => new Date(b?.event_date) - new Date(a?.event_date)
            //         );
            //         console.log('✌️sortedNDRHistory --->', sortedNDRHistory);

            //         // Get the latest entry
            //         const latestNDR = sortedNDRHistory[0];
            //         console.log('✌️latestNDR --->', latestNDR);
            //         const latestCourierAttempt = sortedNDRHistory?.find(entry => entry.By === "courier");
            //         return (
            //             <>
            //                 <div className="tooltip-container">
            //                     {latestNDR?.total_attempts ? latestNDR?.total_attempts : latestCourierAttempt?.total_attempts} Attempt(s)<br />{latestNDR?.courier_remarks}<br />
            //                     <div className="tooltip-text tooltip-above">
            //                         {latestNDR?.courier_remarks}
            //                     </div>
            //                 </div>
            //                 <p className="text-blue-600 cursor-pointer" onClick={() => handleShowHistory(row)} >Show History</p>
            //             </>
            //         );
            //     },
            // },
            {
                name: "Action",
                cell: renderActionCell,
                width: "150px",

            },
        ];
    }, [renderActionCell]);
    const handleDateChange = useCallback((range) => {
        setFinalRange(range);
    }, []);

    const resetData = () => {
        setPage(1);
        setFilter("");
        setSearchUser("");
        setawbNumber("");
        setFilterOrder("");
        setorderStatus('actionRequired');
        setSelectedPaymentType('');
        setActiveTab('Action Required');
        handleClear();

        const defaultRange = getDateRange("Last 30 Days");
        setFinalRange({
            filterType: "Last 30 Days",
            startDate: defaultRange?.startDate,
            endDate: defaultRange?.endDate,
        });

        handleDateChange({
            filterType: "Last 30 Days",
            startDate: defaultRange?.startDate,
            endDate: defaultRange?.endDate,
        });
    }
    const transformDataForExport = (data) => {
        // console.log('✌️data --->', data);
        return data?.map((shipment, index) => {
            // console.log('✌️shipment --->', shipment);
            const fullAddress = shipment?.deliveryAddress?.address1 || '';
            const city = shipment?.deliveryAddress?.city || '';
            const state = shipment?.deliveryAddress?.stateId?.name || '';
            const zipCode = shipment?.deliveryAddress?.zipCode || '';
            const sortedNDRHistory = [...shipment?.ndr_history].sort(
                (a, b) => new Date(a?.event_date) - new Date(b?.event_date)
            );
            // console.log('✌️sortedNDRHistory --->', sortedNDRHistory);
            const date = sortedNDRHistory.length > 0
                ? moment(sortedNDRHistory[0]?.event_date).format("DD/MM/YYYY")
                : "N/A";



            // Get the latest entry
            const latestNDR = sortedNDRHistory[0];
            const latestCourierAttempt = sortedNDRHistory?.find(entry => entry?.By === "courier");


            return {
                "ID": shipment?.order_id,
                "NDR Date": date,
                "Pickup Date": moment(shipment?.createdAt).format("DD/MM/YYYY"),
                "Order Number": shipment?.order_number,
                "Product Name": shipment?.ProductName,
                "Payment Type": shipment?.payment_type,
                "Order Amount": shipment?.ProductPrice,
                "AWB Number": shipment?.awb_number,
                "Order Status": shipment?.status,
                "Customer Name": shipment?.deliveryAddress?.name,
                "Customer Phone": shipment?.deliveryAddress?.phone,
                "Shipping Address": fullAddress,
                "City": city,
                "State": state,
                "Pincode": zipCode,
                "Last Action By": latestNDR?.By,
                "Attempts": latestCourierAttempt.total_attempts,
                "Details": latestNDR?.courier_remarks,
            };
        });
    };

    const downloadExcel = async () => {
        const { data } = await fetchAllOrders({
            variables: {
                page: page,
                limit: 100000,
                "sort": { key: "createdAt", type: -1 },
                paymentType: selectedPaymentType,
                "filter": filter?.trim(),
                from: finalRange?.startDate?.toISOString(), // Use updated startDate
                to: finalRange?.endDate?.toISOString(),
                status: orderStatus,
            },
            fetchPolicy: "cache-and-network"
        });
        // console.log('✌️data --->', data);

        if (!data?.getNDRList?.count) {
            toast.error("No data available for export")
            return;
        }

        // Transform data for export
        const transformedData = transformDataForExport(data?.getNDRList?.data);

        // Create worksheet
        const worksheet = XLSX.utils.json_to_sheet(transformedData);

        // Create workbook
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Exception");

        // Generate and download the Excel file
        XLSX.writeFile(workbook, "Exception.xlsx");
    };

    return (
        <>

            {/* Header */}
            <Header />

            <div className="flex min-h-screen bg-slate-100 overflow-hidden">
                {/* Sidebar */}

                <SideBar />

                {/* Main Content */}
                <div className="flex-1 space-y-3 px-0 py-6 md:p-6 overflow-x-hidden ml-16">
                    <h1 className="text-xl font-bold px-4 md:px-0 mb-3">Non-Delivery Report</h1>
                    <div className="bg-slate-100">
                        <div className="p-6 bg-white border rounded-lg space-y-6">
                            {/* Header Section */}
                            <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center">
                                <div className="flex items-center md:space-x-3">
                                    <BsBox className="text-2xl hidden md:block text-gray-900 " />
                                    <h1 className="text-lg font-bold text-gray-800">
                                        Domestic Shipment Services Across India
                                    </h1>
                                </div>
                                <div className="flex items-center mt-4 lg:mt-0 space-x-6">

                                    <div className="flex space-x-3">
                                        <button onClick={downloadExcel} className="flex items-center gap-2 text-sm  px-4 py-1 bg-slate-700 text-white rounded-lg hover:bg-slate-800">
                                            <FiDownload className="text-lg" />
                                            Export
                                        </button>
                                        <button
                                            onClick={() => setShowFilters(!showFilters)}
                                            className="flex items-center gap-2 text-sm px-4 py-1 bg-slate-700 text-white rounded-lg hover:bg-slate-800"
                                        >  {showFilters ? <FiX className="text-lg" /> : <FiFilter className="text-lg" />}
                                            {showFilters ? "Close" : "Filter"}
                                        </button>

                                    </div>
                                </div>
                            </div>

                            {/* Filter Section */}
                            {showFilters && (
                                <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6">
                                    {/* Search Filter */}
                                    <div className="space-y-2">
                                        <label className="block text-sm font-medium text-gray-700">Custom Search</label>
                                        <input
                                            type="text"
                                            value={searchUser}
                                            onChange={(e) => { setSearchUser(e.target.value); handleSearch(e) }}
                                            // onKeyDown={handleSearch}
                                            placeholder="Search..."
                                            className="w-full border border-gray-300 rounded-md  px-3 py-1.5 text-gray-700 focus:ring-1 focus:ring-slate-900 focus:outline-none"
                                        />
                                    </div>


                                    {/* Order IDs */}
                                    <div className="space-y-2">
                                        <label className="block text-sm font-medium text-gray-700">
                                            Customer
                                        </label>
                                        <input
                                            type="text"
                                            value={filterOrder}
                                            onChange={(e) => { handleSearch(e, 'orderId') }}                                        // onKeyDown={() => handleSearch('orderId')}
                                            placeholder="Customer Name"
                                            className="w-full border border-gray-300 rounded-md  px-3 py-1.5 text-gray-700 focus:ring-1 focus:ring-slate-900 focus:outline-none"
                                        />
                                    </div>

                                    {/* AWB Numbers */}
                                    <div className="space-y-2">
                                        <label className="block text-sm font-medium text-gray-700">
                                            AWB No.
                                        </label>
                                        <input
                                            type="text"
                                            value={awbNumber}
                                            onChange={(e) => { setawbNumber(e.target.value); handleSearch(e, 'awbNumber') }}
                                            placeholder="AWB Nos (comma-separated)"
                                            className="w-full border border-gray-300 rounded-md  px-3 py-1.5 text-gray-700 focus:ring-1 focus:ring-slate-900 focus:outline-none"
                                        />
                                    </div>

                                    {/* Type Filter */}
                                    <div className="space-y-2">
                                        <label className="block text-sm font-medium text-gray-700">Payment Type</label>
                                        <Select
                                            options={typeOptions}
                                            defaultValue={typeOptions[0]}
                                            className="w-full"
                                            value={typeOptions.find(option => option?.value === selectedPaymentType) || null}
                                            onChange={(selectedOption) => setSelectedPaymentType(selectedOption?.value)}
                                            classNamePrefix="react-select"
                                            styles={{
                                                control: (base, state) => ({
                                                    ...base,
                                                    borderColor: state.isFocused ? '#d1d5db' : '#d1d5db',
                                                    '&:hover': { borderColor: '#64748B' },
                                                    boxShadow: state.isFocused ? '0 0 0 0px #000000' : 'none',
                                                    borderRadius: '0.375rem',
                                                }),
                                                singleValue: (base) => ({
                                                    ...base,
                                                    color: '#000000',
                                                    fontSize: '0.875rem',
                                                }),
                                                option: (base, state) => ({
                                                    ...base,
                                                    backgroundColor: state.isSelected ? '#cbd5e1' : state.isFocused ? '#cbd5e1' : 'white',
                                                    color: state.isSelected ? '#000000' : '#000000',
                                                    fontSize: '0.875rem',
                                                    '&:hover': {
                                                        backgroundColor: '#cbd5e1',
                                                        color: '#000000',
                                                        fontSize: '0.875rem',
                                                    }
                                                }),
                                                placeholder: (base) => ({
                                                    ...base,
                                                    fontSize: '14px',
                                                    color: '#A3AAB5',
                                                    fontSize: '0.875rem',
                                                }),
                                            }}
                                        />
                                    </div>


                                    <div className="space-y-2">
                                        <label className="block text-sm font-medium text-gray-700">From Date:</label>
                                        <DateFilter onDateChange={handleDateChange} defaultFilterType={finalRange?.filterType} />
                                    </div>
                                    <div className="flex items-end h-full" onClick={resetData}>
                                        <p className="font-medium mb-1 cursor-pointer bg-slate-300 text-black px-4 py-1.5 rounded-lg text-sm hover:bg-slate-400">
                                            Reset Filters
                                        </p>
                                    </div>
                                </div>
                            )}
                            {/* Tab Section */}
                            <div className="border-t">
                                <div className="flex flex-wrap gap-4 mt-6">
                                    {[
                                        { label: "Action Required", count: NDRDataCount?.getNDRCounts?.actionRequiredCount },
                                        { label: "Action Requested", count: NDRDataCount?.getNDRCounts?.actionRequestedCount },
                                        { label: "Delivered", count: NDRDataCount?.getNDRCounts?.deliveredCount },
                                        { label: "RTO", count: NDRDataCount?.getNDRCounts?.rtoCount },
                                    ].map((tab) => (
                                        <button
                                            key={tab?.label}
                                            onClick={() => handleTabClick(tab?.label)}
                                            className={`px-4 py-1 shadow-md text-sm font-medium rounded-md ${activeTab === tab?.label
                                                ? "bg-slate-900 text-white"
                                                : "bg-white text-gray-700 border border-gray-300 hover:bg-slate-100"
                                                }`}
                                        >
                                            {tab?.label} {(tab?.count || tab?.count === 0) ? `(${tab?.count}) ` : ""}
                                        </button>
                                    ))}
                                </div>

                            </div>


                        </div>

                        {activeTab === "Action Required" && <div className="flex mt-3 flex-wrap items-center bg-white gap-2 p-2 border rounded-lg w-full">
                            {/* Selected Count */}
                            <div className="px-4 rounded-lg hover:bg-slate-200 transition text-gray-900 font-semibold text-sm flex items-center">
                                <span className="text-lg">{selectedRow?.length || 0}</span>
                                <span className="ml-1 text-gray-600 text-sm">selected</span>
                            </div>

                            {/* Bulk NDR Button */}
                            <button
                                className={`px-4 py-1 ${selectedRow?.length === 0 ? "bg-slate-400 cursor-not-allowed" : "bg-gray-900 hover:bg-gray-800 transition-all duration-300"}  text-white text-sm font-semibold rounded-lg `}
                                onClick={() => setOpenSideMenu(true)} // Function to handle Bulk NDR action
                                disabled={selectedRow?.length === 0} // Disable if no items selected

                            >
                                Bulk NDR
                            </button>
                        </div>}
                    </div>

                    <div className="mt-2 bg-white p-4 border rounded-lg">
                        <Table
                            key={forceUpdate}
                            columns={NDRTableColumns}
                            data={orderData || []}
                            currentPage={page}
                            totalRecords={GetOrderOrder?.getNDRList?.count || 0}
                            limit={limit}
                            setLimit={setLimit}
                            setPage={setPage}
                            loading={loading}
                            // expandableRowExpanded={(row) => expandedRows[row.order_id]}
                            // expandableRowsComponent={({ data }) => (
                            //     <div className="bg-gray-50 p-4 mt-2 border rounded-lg">
                            //         <table className="w-full text-left border-collapse">
                            //             <thead>
                            //                 <tr className="bg-gray-200 text-gray-700">
                            //                     <th className="p-2 border">Date</th>
                            //                     <th className="p-2 border">Action</th>
                            //                     <th className="p-2 border">Remarks</th>
                            //                     <th className="p-2 border">Attempt #</th>
                            //                     <th className="p-2 border">By</th>
                            //                 </tr>
                            //             </thead>
                            //             <tbody>
                            //                 {data.ndr_history?.map((entry, index) => (
                            //                     <tr key={index} className="border">
                            //                         <td className="p-2 border">{entry.event_date}</td>
                            //                         <td className="p-2 border">{entry.action}</td>
                            //                         <td className="p-2 border">{entry.courier_remarks}</td>
                            //                         <td className="p-2 border">{entry.total_attempts}</td>
                            //                         <td className="p-2 border">{entry.by}</td>
                            //                     </tr>
                            //                 ))}
                            //             </tbody>
                            //         </table>
                            //     </div>
                            // )}
                            // handlePagination={handlePagination}
                            // deleteData={DeleteProduct}
                            handlePagination={handlePagination}
                            multiSelectRow={onSelectedRowsChange}
                            clearSelectedRows={toggleCleared}
                        />

                    </div>
                </div>
            </div>



            <Dialog open={openSideMenu} onClose={setOpenSideMenu} className="relative z-50">
                <div
                    transition
                    className="fixed inset-0 bg-black bg-opacity-65 transition-opacity duration-500 ease-in-out data-closed:opacity-0"
                />

                <div className="fixed inset-0 overflow-hidden">
                    <div className="absolute inset-0 overflow-hidden">
                        <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
                            <DialogPanel
                                transition
                                className="pointer-events-auto w-screen max-w-md transform transition duration-500 ease-in-out data-closed:translate-x-full sm:duration-700"
                            >
                                <div className="flex h-full flex-col overflow-y-scroll bg-white shadow-xl">
                                    <div className="flex-1 overflow-y-auto px-4 py-6 sm:px-6">
                                        <div className="flex items-start justify-between">
                                            <DialogTitle className="text-lg font-bold text-gray-900">NDR Submit Form</DialogTitle>
                                            <div className="ml-3 flex h-7 items-center">
                                                <button
                                                    type="button"
                                                    onClick={() => setOpenSideMenu(false)}
                                                    className="relative -m-2 p-2 text-gray-400 hover:text-gray-500"
                                                >
                                                    <span className="absolute -inset-0.5" />
                                                    <span className="sr-only">Close panel</span>
                                                    <IoClose aria-hidden="true" className="size-6" />
                                                </button>
                                            </div>
                                        </div>

                                        <Formik
                                            initialValues={{
                                                action: "",
                                                date: "",
                                                remark: "",
                                                address_1: "",
                                                address_2: "",
                                                name: "",
                                                phone: ""
                                            }}
                                            validationSchema={validationSchema}
                                            onSubmit={async (values, { resetForm }) => {
                                                try {
                                                    // console.log('✌️values --->', values);
                                                    if (!selectedRow || selectedRow.length === 0) {
                                                        toast.error("No AWB selected!");
                                                        return;
                                                    }
                                                    // Create request body for each AWB in selectedRow
                                                    const requestBody = selectedRow?.map((awb) => ({
                                                        awb_number: awb, // Process each AWB dynamically
                                                        user_action: values?.action,
                                                        action_data: values.action === "re-attempt"
                                                            ? { re_attempt_date: values?.date }
                                                            : values.action === "change_address"
                                                                ? {
                                                                    name: values?.name || "", // Assuming you have a name field
                                                                    address_1: values?.address_1 || "",
                                                                    address_2: values?.address_2 || ""
                                                                }
                                                                : values.action === "change_phone"
                                                                    ? { phone: values?.phone || "" }
                                                                    : {},
                                                    }));


                                                    const { data } = await createNDRAction({ variables: { input: requestBody } });
                                                    // console.log('✌️data --->', data);

                                                    if (data?.createNDRAction) {
                                                        refetch();
                                                        refetchNDRCount();
                                                        setOpenSideMenu(false);
                                                        setselectedRow([])
                                                        toast.success("NDR Submitted Successfully");
                                                    } else {
                                                        toast.error("Failed to submit action.");
                                                        setOpenSideMenu(false);
                                                        setselectedRow([])
                                                    }

                                                } catch (error) {
                                                    toast.error(error.message || "Something went wrong!"); // Display error in UI
                                                }

                                                resetForm();
                                            }}
                                        >
                                            {({ setFieldValue, values }) => (
                                                <Form>
                                                    {/* Dropdown */}
                                                    <label className="block text-gray-700 text-sm mt-9 mb-2 font-medium">Take Action</label>
                                                    <div className="relative">
                                                        <button
                                                            type="button"
                                                            className="w-full px-3 py-1.5 border border-slate-400 rounded-md bg-white text-gray-700 flex justify-between items-center"
                                                            onClick={() => setIsOpen(!isOpen)}
                                                        >
                                                            {values.action || "Choose Action"}
                                                            <FaAngleDown className="w-4 h-4 text-gray-500" />
                                                        </button>

                                                        {isOpen && (
                                                            <ul className="absolute w-full shadow-lg bg-white border border-slate-400 rounded-md mt-1 z-10">
                                                                {["re-attempt", "change_address", "change_phone"].map((option, index) => (
                                                                    <li
                                                                        key={index}
                                                                        className="px-3 py-1.5 cursor-pointer hover:bg-slate-200 hover:text-black"
                                                                        onClick={() => {
                                                                            setFieldValue("action", option);
                                                                            setIsOpen(false);
                                                                        }}
                                                                    >
                                                                        {option === "re-attempt" ? "Re-Attempt" : option === "change_address" ? "Change Address" : "Change Phone"}
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        )}
                                                    </div>
                                                    <ErrorMessage name="action" component="div" className="text-red-500 text-sm mt-1" />

                                                    {/* Date Picker */}
                                                    {values?.action === "re-attempt" && (
                                                        <>
                                                            <label className="block text-gray-700 text-sm mb-2 font-medium mt-6">Re-Attempt Date</label>
                                                            <Field
                                                                type="date"
                                                                name="date"
                                                                className="w-full px-3 py-1.5 border border-slate-400 rounded-md focus:outline-none"
                                                                min={new Date(new Date().setDate(new Date().getDate() + 1)).toISOString().split("T")[0]}
                                                            />
                                                            <ErrorMessage name="date" component="div" className="text-red-500 text-sm mt-1" />
                                                        </>
                                                    )}

                                                    {/* Address Inputs */}
                                                    {values?.action === "change_address" && (
                                                        <>
                                                            <label className="block text-gray-700 text-sm mb-2 font-medium mt-6">Name</label>
                                                            <Field
                                                                type="text"
                                                                name="name"
                                                                className="w-full px-3 py-1.5 border border-slate-400 rounded-md focus:outline-none"
                                                                placeholder="Enter Name"
                                                            />
                                                            <ErrorMessage name="name" component="div" className="text-red-500 text-sm mt-1" />

                                                            <label className="block text-gray-700 text-sm mb-2 font-medium mt-6">Address 1</label>
                                                            <Field
                                                                type="text"
                                                                name="address_1"
                                                                className="w-full px-3 py-1.5 border border-slate-400 rounded-md focus:outline-none"
                                                                placeholder="Enter Address 1"
                                                            />
                                                            <ErrorMessage name="address_1" component="div" className="text-red-500 text-sm mt-1" />

                                                            <label className="block text-gray-700 text-sm mb-2 font-medium mt-3">Address 2</label>
                                                            <Field
                                                                type="text"
                                                                name="address_2"
                                                                className="w-full px-3 py-1.5 border border-slate-400 rounded-md focus:outline-none"
                                                                placeholder="Enter Address 2"
                                                            />
                                                            <ErrorMessage name="address_2" component="div" className="text-red-500 text-sm mt-1" />
                                                        </>
                                                    )}

                                                    {/* Phone Input */}
                                                    {values.action === "change_phone" && (
                                                        <>
                                                            <label className="block text-gray-700 text-sm mb-2 font-medium mt-6">Phone</label>
                                                            <Field
                                                                type="text"
                                                                name="phone"
                                                                className="w-full px-3 py-1.5 border border-slate-400 rounded-md focus:outline-none"
                                                                placeholder="Enter Phone Number"
                                                            />
                                                            <ErrorMessage name="phone" component="div" className="text-red-500 text-sm mt-1" />
                                                        </>
                                                    )}

                                                    {/* Submit Button */}
                                                    <div className="mt-6">
                                                        <button type="submit" className="w-full px-4 py-2 bg-slate-800 text-white rounded-md hover:bg-slate-900 transition">
                                                            Submit {loaderCreateNdr && <SpinLoader />}
                                                        </button>
                                                    </div>
                                                </Form>

                                            )}
                                        </Formik>
                                    </div>
                                    <div className="border-t bg-slate-50 border-gray-200 px-4 py-6 sm:px-6">

                                        <p className='text-sm text-center'>We noticed that your recent shipment could not be delivered. To help us resolve this issue quickly,</p>

                                    </div>
                                </div>
                            </DialogPanel>
                        </div>
                    </div>
                </div>
            </Dialog>
            <NDRTableHistory open={open} setOpen={setOpen} selectedRowData={selectedRowData?.ndr_history} />
        </>
    )
}

export default NDRDash
